/** @jsxImportSource @emotion/react */
import { css, keyframes } from "@emotion/react";
import { type FC } from "react";

const spin = keyframes`
  to { 
    transform: rotate(360deg); 
  }
`;

export const PageLoader: FC = () => (
  <div
    css={css`
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
      min-height: 200px;
    `}
  >
    <div
      css={css`
        width: 32px;
        height: 32px;
        border: 3px solid var(--color-gray-200);
        border-top-color: var(--color-blue-500);
        border-radius: 50%;
        animation: ${spin} 1s linear infinite;
      `}
    />
  </div>
);
